import { useSimilarProducts } from '@/hooks/productHooks'
import { Button } from '@/components/ui/button'
import { Skeleton } from '@/components/ui/skeleton'
import ProductCard from './store/ProductCard' 

const SimilarProducts = ({ cityId, storeTypeId, categoryId, excludeProductId }) => {
  const {
    data,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    isLoading,
  } = useSimilarProducts({
    city_id: cityId,
    store_type_id: storeTypeId,
    product_category_id: categoryId,
    exclude_product_id: excludeProductId,
  })

  const products = data?.pages.flatMap(page => page.data) || []

  if (isLoading) {
    return (
      <div className="space-y-4">
        <h2 className="text-xl font-semibold">منتجات مشابهة</h2>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
          {[...Array(5)].map((_, i) => (
            <Skeleton key={i} className="h-64 w-full rounded-lg" />
          ))}
        </div>
      </div>
    )
  }

  if (!products.length) return null

  return (
    <div className="space-y-4">
      <h2 className="text-xl font-semibold">منتجات مشابهة</h2>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
        {products.map(product => (
          <ProductCard key={product.id} product={product} />
        ))}
      </div>
      {hasNextPage && (
        <div className="flex justify-center">
          <Button variant="outline" onClick={() => fetchNextPage()} disabled={isFetchingNextPage}>
            {isFetchingNextPage ? 'جاري التحميل...' : 'تحميل المزيد'}
          </Button>
        </div>
      )}
    </div>
  )
}

export default SimilarProducts